"use client";

import { Button } from "@heroui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogPortal,
  DialogTitle,
} from "@/components/common/Dialog";
import { useState } from "react";
import EyeIcon from "@/components/logos/EyeIcon";
import LockIcon from "@/components/logos/LockIcon";
import { toast } from "sonner";
import { MdOutlineFileDownload } from "@react-icons/all-files/md/MdOutlineFileDownload";

interface RecoveryKeyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  recoveryKey: string;
  onContinue?: () => void;
}

const RecoveryKeyModal = ({
  open,
  onOpenChange,
  recoveryKey,
  onContinue,
}: RecoveryKeyModalProps) => {
  const [isKeyVisible, setIsKeyVisible] = useState(false);
  // const [isRecoveryConfirmationModalOpen, setIsRecoveryConfirmationModalOpen] =
  //   useState(false);

  const handleDownloadKey = async () => {
    try {
      const blob = new Blob([recoveryKey], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "reactor_private_key.txt";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Recovery key downloaded");
    } catch (err) {
      console.error("Failed to copy key:", err);
    }
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogPortal>
          <DialogContent
            className="flex w-[95%] !max-w-[510px] flex-col items-center gap-4 rounded-[25px] py-6 md:w-full md:gap-[18px] md:py-[44px]"
            blur={false}
          >
            <DialogHeader className="hidden">
              <DialogTitle hidden>Recovery Code</DialogTitle>
            </DialogHeader>

            <div className="relative flex h-[60px] w-[60px] items-center justify-center md:h-[72px] md:w-[72px]">
              <div className="absolute inset-0 rounded-full bg-[#1C2D27]" />
              <LockIcon className="relative z-[2]" />
            </div>

            <h2 className="font-clash max-w-[280px] text-center text-2xl font-medium leading-none text-foreground md:text-[30px]">
              This is your wallet{"'"}s Private Key
            </h2>

            <button
              onClick={() => {
                if (isKeyVisible) {
                  handleDownloadKey();
                } else {
                  setIsKeyVisible(true);
                }
              }}
              className="group relative flex h-[50px] w-[90%] items-center justify-between rounded-[14px] border border-[#21212F] bg-[#111119] p-3 outline-none md:h-[80px] md:w-[300px] md:p-4"
            >
              <p className="flex-1 truncate font-mono text-base text-muted-foreground md:text-lg">
                {recoveryKey}
              </p>
              <div className="absolute bottom-2 right-2 flex items-center justify-center rounded-[7px]">
                <MdOutlineFileDownload className="size-5 text-muted-foreground" />
              </div>
              {!isKeyVisible && (
                <div className="absolute inset-[1px] flex items-center justify-center rounded-[14px] backdrop-blur-[13px]">
                  <div className="flex items-center gap-2 text-gray-p">
                    <EyeIcon className="size-4 md:size-5" />
                    <span className="font-clash text-xs font-medium md:text-[14px]">
                      Show my key
                    </span>
                  </div>
                </div>
              )}
            </button>

            <p className="font-clash text-xs font-medium uppercase leading-[2.14] text-foreground md:text-[14px]">
                DOWNLOAD IT {">"} DO NOT SHARE THESE KEYS
            </p>

            <Button
              onPress={() => {
                onContinue?.();
              }}
              className="h-[46px] w-[90%] rounded-[12px] bg-[#1C3028] text-sm font-semibold text-green transition-colors hover:!bg-[#1C3028]/80 md:h-[56px] md:w-[220px] md:text-medium"
              variant="flat"
            >
              Launch
            </Button>

            {/* <p className="text-xs text-gray-p md:text-[14px]">
              Don{"'"}t store it in your downloads folder like a normie.
            </p> */}
          </DialogContent>
        </DialogPortal>
      </Dialog>

      {/* <RecoveryConfirmationModal
        open={isRecoveryConfirmationModalOpen}
        onCancel={() => setIsRecoveryConfirmationModalOpen(false)}
        onConfirm={() => onOpenChange(false)}
      /> */}
    </>
  );
};

export default RecoveryKeyModal;
